export const GLOBAL_MERCHANT = 'UNO_GLOBAL'
export const MAX_ORDER_QUANTITY = 10
